export default __webpack_public_path__ + "static/media/a037-f.4aa3cab2.jpg";